export default __webpack_public_path__ + "static/media/noContent.c41f6d56.png";